'use client'

import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import styles from "./ua.module.scss";
import { DMField } from "@dealermesh/react";
import { formatCurrency } from "@/utils/Formatters";

const Field = forwardRef((props, ref) => {
  
  const [value,setValue] = useState(props.value || '')
  
  const field = useRef()

  useEffect(() => {
    setValue(props.value)
  }, [props.value])
  
  const updateValue = (value) => {
    setValue(value)
    field.current.setValue(value)
  }
  
  useImperativeHandle(ref, () => ({
    updateValue
  }))
  
  const handleChange = (field,value) => {
    setValue(value)
    props.onChange(value)
  }
  
  const fieldStyle = () => {
    if (props.type == 'slider') {
      const p = (((value || 0) - props.min) / (props.max - props.min)) * 100
      return {
        backgroundSize: p + '% 100%'
      }
    }
    return {}
  }
  
  const onFocus = (e) => {
    e.preventDefault()
  }
  
  const onBlur = (e) => {
    e.preventDefault()
    if (props.onBlur) props.onBlur(e)
  }
  
  if (props.type == "hidden") {
    return <DMField ref={field} {...props} value={value}></DMField>
  }
  
  return <div className={ styles.grp + ' ' + (props.transparent ? styles.trn : '') + ' ' + (props.inline ? styles.inline : '') }>
    { props.inline && props.label &&
    <label style={{ width: props.labelWidth }}>{ props.label }</label>
    }
    <div>
      { props.type ?
      <DMField id={props.id} ref={field} {...props} value={value} onChange={(field,value) => handleChange(field,value)} onFocus={e => onFocus(e)} onBlur={e => onBlur(e)} style={fieldStyle()}>
      </DMField>
      :
      props.children
      }
      { props.type == 'slider' &&
      <div className={ styles.legend }>
        <div>{ formatCurrency(props.min) }</div>
        <div>{ formatCurrency(props.max) }</div>
      </div>
      }
    </div>
  </div>
  
})

Field.displayName = 'Field';
export default Field